import { Fragment } from "react";

import ProfileSectionRow from "@/components/home/sections/components/ProfileSectionRow";
import ProfileWorkExperienceItem from "@/components/home/sections/components/ProfileWorkExperienceItem";
import type { ISectionProps } from "@/components/home/sections/ProfileBioSection";
import ProfileSectionCard from "@/components/home/sections/ProfileSectionCard";
import { DatePeriodSegment } from "@/components/ui/DatePeriodSegment";
import { ItemSectionDivider } from "@/components/ui/ItemSectionDivider";
import type { CommonModels } from "@/data/common/common.models";
import { ProfileUtils } from "@/util/profile.utils";

interface IProps extends ISectionProps {
  volunteer?: CommonModels.VolunteerExperienceDto[];
}

const ProfileVolunteerSection = ({
  volunteer,
  onEditSectionClicked,
  isPublic = false,
  enableInViewAnimation,
}: IProps) => {
  const filteredVolunteer = volunteer?.filter((item) => {
    return Object.values(item).some((value) => {
      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (typeof value === "object")
        return Object.values(value).some((value) => {
          if (value === null || value === undefined) return false;
          if (typeof value === "string") return value.trim() !== "";
          return true;
        });
      return true;
    });
  });

  return (
    <ProfileSectionCard
      title="Volunteer and Community"
      isEmpty={!filteredVolunteer || filteredVolunteer.length === 0}
      onEditSectionClicked={onEditSectionClicked}
      isPublic={isPublic}
      enableInViewAnimation={enableInViewAnimation}
    >
      <div className="mt-6 flex flex-col gap-6">
        {volunteer?.map((item, index) => (
          <Fragment key={index}>
            <ProfileSectionRow
              title={item.organization_name}
              subTitle={
                <DatePeriodSegment
                  className="text-text-default-3"
                  period={item.period}
                />
              }
              index={index}
              sectionId="volunteer-volunteer"
              hasAdditionalInfo={!!item.role || !!item.description}
            >
              <ProfileWorkExperienceItem
                value={item.role}
                segment="Role"
              />
              <ProfileWorkExperienceItem
                value={item.description}
                segment="Description"
              />
              <ProfileWorkExperienceItem
                value={ProfileUtils.getDisplayAddress(item.location)}
                segment="Location"
              />
            </ProfileSectionRow>
            {index !== volunteer.length - 1 && <ItemSectionDivider />}
          </Fragment>
        ))}
      </div>
    </ProfileSectionCard>
  );
};

export default ProfileVolunteerSection;
